const paymentRejectedDialogStyle = () => ({
	paymentRejectedBody: {
		marginBottom: 60,
	},
});

export default paymentRejectedDialogStyle;
